// Piezas compartidas por la ficha de proveedor (components/proveedor/*).
// Antes vivían mezcladas con las siete secciones en un solo archivo de ~3,000
// líneas, donde cualquier cambio obligaba a leerlo entero.

export const ACCENT = "#1b4d2e";

export const normalizeInstagramHandle = (value) => {
  if (!value) return "";
  return value
    .trim()
    .replace(/^https?:\/\/(www\.)?instagram\.com\//i, "")
    .replace(/[/?#].*$/, "")
    .replace(/^@+/, "")
    .trim();
};

export const fmtMoney = (v) => {
  const n = Number(v);
  if (!isFinite(n)) return "-";
  return (
    "$" +
    Math.abs(n).toLocaleString("es-MX", {
      minimumFractionDigits: n % 1 !== 0 ? 2 : 0,
      maximumFractionDigits: 2,
    })
  );
};

export const fmtDate = (ts) => {
  if (!ts?.toDate) return "—";
  return ts.toDate().toLocaleDateString("es-MX", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const STATUS_OPTIONS = [
  { value: "activo", label: "Activo" },
  { value: "inactivo", label: "Inactivo" },
  { value: "bloqueado", label: "Bloqueado" },
];

export const newId = () =>
  typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID()
    : `c_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;

export const InfoField = ({ label, children }) => (
  <div>
    <dt className="text-xs uppercase tracking-wide font-semibold text-zinc-500">{label}</dt>
    <dd className="mt-1 text-sm text-zinc-900 dark:text-zinc-100 break-words">{children}</dd>
  </div>
);

// ── Primitivas de la ficha ───────────────────────────────────────────
// La ficha tenía cuatro recetas de tarjeta conviviendo y 14 de ellas sin
// variante dark (se quedaban blancas en modo oscuro). Estas son las del
// resto del app —las más usadas con diferencia— y ahora viven en un solo
// lugar para que no vuelvan a divergir.

export const CARD =
  "rounded-xl border border-zinc-200 dark:border-zinc-700/60 bg-white dark:bg-zinc-800/50 shadow-sm";

export const INPUT =
  "w-full rounded-lg border border-zinc-300 dark:border-zinc-600 bg-white dark:bg-zinc-800 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#1b4d2e]";

export const Card = ({ className = "", children, ...rest }) => (
  <div className={`${CARD} ${className}`} {...rest}>
    {children}
  </div>
);

// Encabezado de bloque dentro de una sección.
export const BloqueTitulo = ({ children, hint }) => (
  <div className="mb-3">
    <div className="text-xs uppercase tracking-wide font-semibold text-zinc-500">
      {children}
    </div>
    {hint && <p className="mt-1 text-xs text-zinc-500">{hint}</p>}
  </div>
);

// Verde de marca en <button> crudo, no <Button color="green">: es la regla
// del proyecto para los CTA primarios. Dos tamaños y ya — antes convivían
// cuatro formas distintas del mismo botón, una hasta con otro font-weight.
export const BTN_PRIMARIO =
  "inline-flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-semibold text-white shadow-sm transition hover:opacity-90 disabled:opacity-50";

// El secundario (cancelar, acciones de apoyo) tenía tres recetas: dos
// tamaños y dos font-weight distintos, uno de ellos sin fondo. Espeja al
// primario para que el par se lea como un par.
export const BTN_SECUNDARIO =
  "inline-flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-semibold text-zinc-700 bg-zinc-100 hover:bg-zinc-200 transition disabled:opacity-50";

export const BTN_SECUNDARIO_SM =
  "inline-flex items-center gap-1.5 shrink-0 px-3 py-1.5 rounded-lg text-xs font-semibold text-zinc-700 bg-zinc-100 hover:bg-zinc-200 transition disabled:opacity-50";

export const BTN_PRIMARIO_SM =
  "inline-flex items-center gap-1.5 shrink-0 px-3 py-1.5 rounded-lg text-xs font-semibold text-white shadow-sm transition hover:opacity-90 disabled:opacity-50";

export const Vacio = ({ children }) => (
  <p className="text-sm text-zinc-400 dark:text-zinc-500 italic py-6 text-center">
    {children}
  </p>
);
